import React from 'react';
import { connect } from 'react-redux';
import i18n from 'I18n';
import { getMaxCashDollar } from 'component/profile/PointAndCashSection';
import { headerCustomParameterType } from 'frontend_common/HeaderConfig';
import { APP_NAME } from 'utils/Config';
import BaseLeftSection from './BaseLeftSection';
import { enLocaleNumberFormatter } from 'utils';

const getCustomParameterValue = (
  headerCustomParameter,
  displayName,
  availablePoints,
  level,
  levelConfig,
) => {
  if (headerCustomParameter === headerCustomParameterType.displayName) {
    return displayName;
  };
  if (headerCustomParameter === headerCustomParameterType.appName) {
    return APP_NAME;
  };
  if (headerCustomParameter === headerCustomParameterType.points) {
    return enLocaleNumberFormatter(availablePoints);
  };
  if (headerCustomParameter === headerCustomParameterType.cash) {
    return enLocaleNumberFormatter(getMaxCashDollar(availablePoints));
  };
  if (headerCustomParameter === headerCustomParameterType.levelName) {
    let levelIndex = 0;
    // eslint-disable-next-line no-unused-expressions
    levelConfig?.forEach((item, index) => {
      if (item.id === level) {
        levelIndex = index;
      }
    });
    const currentColorConfig = levelConfig?.[levelIndex];
    return currentColorConfig?.name;
  };
  return null;
};

const CustomLeftComponent = ({
  language,
  isLogin,
  availablePoints,
  displayName,
  level,
  levelConfig,
  navBarConfig,
}) => {
  const customParameterValue = getCustomParameterValue(
    navBarConfig.headerCustomParameter,
    displayName,
    availablePoints,
    level,
    levelConfig,
  );

  if (navBarConfig.headerCustomParameter === headerCustomParameterType.appName) {
    return (
      <BaseLeftSection
        title={i18n.t(navBarConfig.headerCustomWording)}
        content={customParameterValue}
      />
    )
  }

  if (!isLogin) {
    return null;
  };

  return (
    <BaseLeftSection
      title={i18n.t(navBarConfig.headerCustomWording)}
      content={customParameterValue}
    />
  );
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  availablePoints: state.users.availablePoints,
  displayName: state.users.displayName,
  level: state.users.level,
  levelConfig: state.users.levelConfig,
})

export default connect(mapStateToProps)(CustomLeftComponent);
